<app-overlay
  (overlayClick)="onOverlayClick()"
  *ngIf="isAsideMenuVisible"
></app-overlay>
<div
  [class.app-aside--collapsed]="isAsideCollapsed"
  [class.app-aside--with-appcues-banner]="isAppcuesBannerVisible"
  class="app-aside"
>
  <div class="app-aside__container">
    <app-book-now
      (bookNowClick)="onBookNowClick()"
      *ngIf="isBookNowVisible"
      [isBookNowChecked]="isAsideMenuVisible"
      [isBookNowCollapsed]="isAsideCollapsed"
      data-cy="aside-book-now"
    ></app-book-now>
    <ng-container>
      <ng-container
        *ngFor="let item of menuItems | slice: 0 : (isMobile ? 5 : menuItems.length); let index = index"
        appNgForTrackByUuid
      >
        <ng-container>
          <app-aside-item
            *ngIf="item.visible"
            (asideItemClick)="onAsideItemClick(index, item)"
            [asideItemNotification]="item.notification"
            [asideItemIconSrc]="item.iconSrc"
            [iconName]="item.iconName"
            [isAsideItemChecked]="index === asideItemCheckedIndex"
            [isAsideItemCollapsed]="isAsideCollapsed"
            [label]="item.label | translate"
            [ngClass]="item.class || ''"
            [qimaTooltipHasArrow]="true"
            [qimaTooltipIsVisible]="isAsideCollapsed"
            [qimaTooltipPosition]="tooltipPosition"
            [qimaTooltipText]="item.tooltip | translate"
            qimaTooltip
            [attr.data-cy]="'aside-menu-item-' + index"
          ></app-aside-item>
        </ng-container>
        <ng-container *ngIf="isSubMenuVisible && item.subItems">
          <div
            [ngClass]="{ subitemCollapsed: isAsideCollapsed, changeSubItemsPosition: isNetworkOnly }"
            class="subitems-dropdown"
          >
            <ng-container
              *ngFor="let subItem of item.subItems; let subIndex = index"
              appNgForTrackByUuid
            >
              <app-aside-item
                (asideItemClick)="onAsideItemClick(subIndex, subItem, item.subItems)"
                [asideItemIconSrc]="subItem.iconSrc"
                [iconName]="subItem.iconName"
                [isAsideItemChecked]="subIndex === subMenuItemCheckedIndex"
                [isAsideItemCollapsed]="isAsideCollapsed"
                [label]="subItem.label | translate"
                [attr.data-cy]="'aside-submenu-item-' + subIndex"
                [qimaTooltipHasArrow]="true"
                [qimaTooltipIsVisible]="isAsideCollapsed"
                [qimaTooltipPosition]="tooltipPosition"
                [qimaTooltipText]="subItem.tooltip | translate"
                qimaTooltip
              >
              </app-aside-item>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <app-aside-item
      (asideItemClick)="onBackToACAClick()"
      *ngIf="isSystemSwitchVisible && isSystemSwitchReady()"
      [iconName]="qimaIcon.iconName.SWITCH"
      [isAsideItemCollapsed]="isAsideCollapsed"
      [label]="'APP_ASIDE.ASIDE_MENU.SYSTEM_SWITCHER_LABEL' | translate"
      [qimaTooltipHasArrow]="true"
      [qimaTooltipIsVisible]="isAsideCollapsed"
      [qimaTooltipPosition]="tooltipPosition"
      [qimaTooltipText]="'APP_ASIDE.ASIDE_MENU.SYSTEM_SWITCHER_LABEL' | translate"
      class="system-switcher"
      qimaTooltip
      data-cy="aside-system-switcher"
    ></app-aside-item>
  </div>
</div>
<app-aside-menu
  [asideMenuDynamicBookingMenus]="dynamicBookingMenus"
  [asideMenuIsVisible]="isAsideMenuVisible"
  data-cy="aside-menu"
></app-aside-menu>
<app-aside-more
  (asideMoreCloseClick)="onAsideMoreCloseClick()"
  (asideMoreMenuClick)="onAsideMoreMenuClick($event)"
  *ngIf="isAsideMoreVisible"
  [asideMoreMenusItems]="menuItems"
  data-cy="aside-more-menu"
></app-aside-more>
